module.exports = __webpack_public_path__ + "img/facebook.37c54d02.svg";